module.exports = __webpack_public_path__ + "static/media/icon_meal.91878297.svg";